<div *ngrxLet="smartlockerDeliveries$; let deliveries; suspenseTpl: loadingTpl" class="d-flex flex-column h-100">
    <h5 class="text-center py-3" [translate]="'SMARTLOCKER_TITLE'"></h5>
    <div class="row align-items-center pe-2">
        <div class="col-10 col-md-11">
            <pace-core-text-input
                [(model)]="searchFilterModel"
                (keyup)="onSearchFilterChange($event)"
            ></pace-core-text-input>
        </div>
        <div class="col-2 col-md-1">
            <button
                type="button"
                class="btn btn-primary"
                (click)="clearFilter()"
                [translate]="'SMARTLOCKER_CLEAR_FILTER_BTN_LABEL'"
            ></button>
        </div>
    </div>
    @if (smartlockers && smartlockers.value.length > 0) {
        <div class="row align-items-center my-3 pe-2">
            <label
                for="smartlockers"
                class="col-form-label text-start"
                [translate]="'SMARTLOCKER_SELECT_PREFERRED_SMARTLOCKER_LABEL'"
            ></label>
            <div class="col-10 col-md-11">
                <pace-core-dropdown
                    id="smartlockers"
                    [(model)]="smartlockers"
                    (valueChange)="onPreferredSmartlockerChange()"
                ></pace-core-dropdown>
            </div>
            <div class="col-2 col-md-1">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="clearPreferredSmartlocker()"
                    [translate]="'SMARTLOCKER_CLEAR_FILTER_BTN_LABEL'"
                ></button>
            </div>
        </div>
    }
    <div class="row my-2">
        <pace-core-checkbox-input
            [(model)]="showDeliveriesOnly"
            (valueChange)="onShowDeliveriesOnlyChange()"
        ></pace-core-checkbox-input>
    </div>
    <div class="flex-grow-1 overflow-auto align-self-md-center w-100">
        @if (deliveries.length > 0) {
            @for (delivery of deliveries; track delivery.SmartlockerDeliveryId) {
                <div class="table-row">
                    <pace-smartlocker-delivery [smartlockerDelivery]="delivery"></pace-smartlocker-delivery>
                </div>
            }
        } @else {
            <div class="d-flex h-100 align-items-center justify-content-center">
                <div [translate]="'SMARTLOCKER_NO_MATCHING_DELIVERIES_FOUND_MESSAGE'"></div>
            </div>
        }
    </div>
</div>
<ng-template #loadingTpl>
    <div class="d-flex h-100 align-items-center justify-content-center">
        <progressbar [value]="100" type="info">
            {{ 'SMARTLOCKER_RETRIEVING_IN_PROGRESS_LABEL' | translate }}
        </progressbar>
    </div>
</ng-template>
